// Generated by Melange

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function DummyTable(Props) {
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-white w-20 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-20 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-34 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-30 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-39 h-4 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-full h-4 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-white w-full h-4 rounded"
              })
            ],
            className: "flex bg-gray-pale gap-2 px-6 py-3 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-20 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-34 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-30 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-5 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-32 h-5 rounded-sm shrink-0"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              }),
              JsxRuntime.jsx("div", {
                className: "bg-gray-pale w-full h-5 rounded"
              })
            ],
            className: "flex gap-2 px-6 py-2.5 border-b border-gray-main"
          })
        ],
        className: "flex-1"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              className: "bg-gray-pale w-24 h-5 rounded"
            }),
            JsxRuntime.jsx("div", {
              className: "bg-gray-pale w-5 h-5 rounded-sm ml-4"
            }),
            JsxRuntime.jsx("div", {
              className: "bg-gray-pale w-5 h-5 rounded-sm ml-2"
            })
          ],
          className: "flex items-center"
        }),
        className: "flex justify-end px-6 py-4 border-t border-gray-main"
      })
    ]
  });
}

const make = DummyTable;

export {
  make,
}
/* react Not a pure module */
